import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const radioButtonStyles = tv({
    slots: {
        base: `
      iris:group
      iris:flex
      iris:cursor-pointer
      iris:gap-(--comp-space-gap-check-radio)
      iris:rounded-(--comp-size-radius-checkbox-control)
      iris:px-(--comp-space-padding-check-radio-all)
      iris:py-(--comp-space-padding-check-radio-all)
      iris:text-left
      iris:duration-(--comp-motion-duration-check-radio)
      iris:ease-(--comp-motion-easing-check-radio)
    `,
        label: `
      iris:min-h-(--base-space-px-24)
      iris:font-(family-name:--comp-type-font-check-radio-label)
      iris:text-(length:--comp-type-size-check-radio-label)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-check-radio-label)!
      iris:tracking-(--comp-type-tracking-check-radio-label)
      iris:transition-all
      iris:duration-(--comp-motion-duration-check-radio)
      iris:ease-(--comp-motion-easing-check-radio)
    `,
        radioWrapper: ` 
      iris:flex
      iris:min-h-(--base-space-px-24)
      iris:items-center
      iris:self-start
    `,
    },
    variants: {
        inverse: {
            true: {
                base: focusStyles.inverse,
                label: `
          iris:text-(--comp-color-content-check-radio-label-inverse-rest)
          iris:group-data-[state=checked]:text-(--comp-color-content-check-radio-label-inverse-selected)
        `,
            },
            false: {
                base: focusStyles.default,
                label: `
          iris:text-(--comp-color-content-check-radio-label-rest)
          iris:group-data-[state=checked]:text-(--comp-color-content-check-radio-label-selected)
        `,
            },
        },
        error: {
            true: {},
            false: {},
        },
        disabled: {
            true: {
                base: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
                radioWrapper: "iris:cursor-not-allowed",
            },
            false: {},
        },
    },
    compoundVariants: [
        {
            inverse: true,
            disabled: false,
            class: {
                label: "iris:group-hover:text-(--comp-color-content-check-radio-label-inverse-hover)",
            },
        },
        {
            inverse: false,
            disabled: false,
            class: {
                label: "iris:group-hover:text-(--comp-color-content-check-radio-label-hover)",
            },
        },
        {
            error: true,
            inverse: false,
            class: {
                label: "iris:text-(--comp-color-content-check-radio-label-error)",
            },
        },
        {
            error: true,
            inverse: true,
            class: {
                label: "iris:text-(--comp-color-content-check-radio-label-inverse-error)",
            },
        },
        {
            disabled: true,
            inverse: false,
            class: {
                label: "iris:text-(--comp-color-content-check-radio-label-rest)",
            },
        },
        {
            disabled: true,
            inverse: true,
            class: {
                label: "iris:text-(--comp-color-content-check-radio-label-inverse-rest)",
            },
        },
    ],
    defaultVariants: {
        inverse: false,
        error: false,
        disabled: false,
    },
});

export { radioButtonStyles as default };
